import { useState } from "react";

import clsx from "clsx";

import { Spinner } from "@components/v2";
import { usePrettyLogEventPage } from "@components/v2/analytics/hooks";
import { useToggleNBV2 } from "@hooks/use-toggle-nb-v2";
import { usePrefs } from "@utils/client-side-preferences";

import { AdminMenu } from "./admin-menu";
import { NavButton } from "./nav-button";
import { NavLink } from "./nav-link";
import { NavOutsideLink } from "./nav-outside-link";

interface Props {
  isExpanded: boolean;
  onShowAdminModal: () => void;
}

export const Sidebar = ({ isExpanded, onShowAdminModal }: Props) => {
  const { useDevelopmentAnalyticsData } = usePrefs();
  const toggleNBV2 = useToggleNBV2();

  const [isSwitchingToOldUI, setIsSwitchingToOldUI] = useState(false);
  const prettyLogEventPage = usePrettyLogEventPage();

  return (
    <div
      className={clsx(
        "h-full border-r border-v2-tertiary px-3 pt-4 pb-6 overflow-hidden",
        "flex flex-col items-stretch justify-between",
        {
          "bg-v2-navbar": !useDevelopmentAnalyticsData,
          "bg-v2-venus/400": useDevelopmentAnalyticsData,
        },
      )}
    >
      <div className="flex flex-col gap-1">
        <NavLink
          to="home"
          icon={<i className="fa-regular fa-house"></i>}
          isExpanded={isExpanded}
          shortcut="H"
          shortcutTo="home/overview"
        >
          Home
        </NavLink>
        <NavLink
          to="attribution"
          icon={<i className="fa-regular fa-chart-line"></i>}
          isExpanded={isExpanded}
          shortcut="S"
          shortcutTo="attribution/sales"
        >
          Attribution
        </NavLink>
        <NavLink
          to="metrics-explorer"
          icon={<i className="fa-regular fa-telescope"></i>}
          isExpanded={isExpanded}
          shortcut="E"
        >
          Metrics Explorer
        </NavLink>
        <NavLink
          to="mmm"
          icon={<i className="fa-regular fa-compass"></i>}
          isExpanded={isExpanded}
          shortcut="M"
        >
          MMM
        </NavLink>
      </div>
      <div className="flex flex-col gap-1">
        <AdminMenu
          isExpanded={isExpanded}
          onShowAdminModal={onShowAdminModal}
        />
        <NavLink
          to="settings/profile"
          icon={<i className="fa-regular fa-gear"></i>}
          isExpanded={isExpanded}
          shortcut="B"
        >
          Settings
        </NavLink>
        <NavOutsideLink
          to="https://docs.northbeam.io/docs/what-is-northbeam"
          icon={<i className="fa-regular fa-question-circle"></i>}
          isExpanded={isExpanded}
          shortcut="P"
        >
          Help
        </NavOutsideLink>
      </div>
    </div>
  );
};
